import { useQuery } from '@tanstack/react-query';
import ApiService from '../../ApiService';

const fetchData = async (advertiserId: number) => {
    const { data } = await ApiService.getHatCreativePixels(advertiserId);
    return data;
};

const useCreativePixelListQuery = (advertiserId: number, apiToken: string) => {
    return useQuery({
        queryKey: ['creativePixelList', advertiserId, apiToken],
        queryFn: () => fetchData(advertiserId),
        staleTime: Infinity,
        enabled: !!advertiserId,
    });
};

export { useCreativePixelListQuery };
